
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/system/sizing",
      function () {
        return require("private-next-pages/system/sizing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/system/sizing"])
      });
    }
  